import {Component} from "@angular/core";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {RouteHelper, RouteMapping} from "../misc/route-helper";
import {AppSettingsService} from "../app-settings/app-settings.service";
import {ManagePartnersService} from "./manage-partners.service";
import {handleErrors} from "../misc/handle-errors.decorator";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DisplayRegistrationLinkDialogComponent} from "./dialog-partner-display-registration-link.component";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 10;

@Component({
  templateUrl: "./manage-partners-list.template.pug",
  providers: [
    ManagePartnersService,
    DialogService,
  ],
})

export class ManagePartnersListComponent extends RouteHelper {
  partners: any[] = [];
  currentPage: number = DEFAULT_PAGE;
  pageSize: number = DEFAULT_PAGE_LIMIT;
  maxPages: number;
  totalCount: number = 0;
  searchText: string = "";
  error: Error;

  paramsMap: RouteMapping[] = [
    {fieldName: "currentPage", paramName: "page", defaultValue: DEFAULT_PAGE, type: "number"} as RouteMapping,
    {fieldName: "pageSize", paramName: "limit", defaultValue: DEFAULT_PAGE_LIMIT, type: "number"} as RouteMapping,
    {fieldName: "searchText", paramName: "search"} as RouteMapping,
  ];

  constructor(
    private managePartnersService: ManagePartnersService,
    public route: ActivatedRoute,
    public router: Router,
    public appSettingsService: AppSettingsService,
    public dialogService: DialogService,
  ) {
    super();
  }

  navigate(queryParams: Params, skipLocationChange: boolean = false): Promise<boolean> {
    return this.router.navigate(["partners"], {queryParams, skipLocationChange});
  }

  @handleErrors()
  async loadData(): Promise<void> {
    const {rows, count} = await this.managePartnersService.getPartners(
      `${this.currentPage - 1}`,
      `${this.pageSize}`,
      this.searchText ? this.searchText : "",
    );

    this.partners = rows;
    this.maxPages = Math.ceil(count / (+this.pageSize));
    this.totalCount = count;
  }

  onListControlsChange(event) {
    switch (event["key"]) {
      case "page":
        this.currentPage = event["value"];
        break;
      case "search":
        this.currentPage = DEFAULT_PAGE;
        this.searchText = event["value"];
        break;
      case "limit":
        this.currentPage = DEFAULT_PAGE;
        this.pageSize = event["value"];
        break;
      default:
        console.info(`Unknown ${event["key"]}`);
        break;
    }
    this.syncRoute();
  }

  @handleErrors()
  async displayPartnerRegistrationLinkDialog(id, registrationLink) {
    await DisplayRegistrationLinkDialogComponent.showDisplayRegistrationLinkDialogModal(
      this.dialogService,
      {
        partnerId: id,
        registrationLink,
      },
    ).toPromise();
  }
}
